import { Theme, css } from '@emotion/react';

export const switchFieldFormControlLabel = (fullWidth?: boolean, labelPlacement?: string) => css`
  justify-content: ${fullWidth && 'space-between'};
  margin-left: ${labelPlacement === 'start' && 0};
`;

export const switchField = ({ spacing }: Theme) => css`
  margin: 0 ${spacing(1)}px;
`;

export const switchFieldHelperText = ({ spacing }: Theme) => css`
  margin-top: ${spacing(1)}px;
`;
